import React, { useState, useEffect } from 'react'
import { TabView, TabPanel } from 'primereact/tabview'
import { Dialog } from 'primereact/dialog'
import { Button } from 'primereact/button'
import './SharedOfficeModal.scss'
import icon from '../../../assets/icons/warning-icon-blue.svg'
import moment from 'moment'
import { useHistory } from 'react-router'
import { useTranslation } from 'react-i18next'

const SharedOfficeModal = (props: { messageTr: any; dayList?: any[]; setVisible: any; visible: any }) => {
  const history = useHistory()
  const { t } = useTranslation()
  let list: any = []
  const close = () => {
    props.setVisible(false)
    // history.push('/home')
  }

  const renderFooter = () => {
    return (
      <div className="grid">
        <div className="col-12" style={{ display: 'flex', flexFlow: 'wrap', justifyContent: 'center' }}>
          <Button onClick={close} label={t('buttons.ok')} className="btnMail" />
        </div>
      </div>
    )
  }

  return (
    <>
      <Dialog
        visible={props.visible}
        style={{ width: '400px', minHeight: '400px', maxHeight: '600px' }}
        footer={renderFooter()}
        onHide={close}>
        <div className="shared-modal-icon">
          <img src={icon} />
        </div>
        <div className="shared-modal-title">{t('overlaypanel-texts.info-header')}</div>
        <div className="shared-modal-header">{props.messageTr}</div>
        <div className="shared-modal-data">
          {props.dayList?.map((item: any) => (
            <div>{moment(item).format('L')}</div>
          ))}
        </div>
      </Dialog>
    </>
  )
}

export default SharedOfficeModal
